import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

/** Opens the deep-link screen once, on top of the home screen, so «Назад» leads home. */
export function DeepLinkRedirect({ route }: { route: string | null }) {
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (!route || done.current) return;
    done.current = true;
    void navigate(route);
  }, [route, navigate]);
  return null;
}
